/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JumboGetadminemailGetAdminEmailResponse
 */
export interface JumboGetadminemailGetAdminEmailResponse {
    /**
     * 
     * @type {string}
     * @memberof JumboGetadminemailGetAdminEmailResponse
     */
    adminEmail?: string;
}

/**
 * Check if a given object implements the JumboGetadminemailGetAdminEmailResponse interface.
 */
export function instanceOfJumboGetadminemailGetAdminEmailResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function JumboGetadminemailGetAdminEmailResponseFromJSON(json: any): JumboGetadminemailGetAdminEmailResponse {
    return JumboGetadminemailGetAdminEmailResponseFromJSONTyped(json, false);
}

export function JumboGetadminemailGetAdminEmailResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): JumboGetadminemailGetAdminEmailResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'adminEmail': !exists(json, 'adminEmail') ? undefined : json['adminEmail'],
    };
}

export function JumboGetadminemailGetAdminEmailResponseToJSON(value?: JumboGetadminemailGetAdminEmailResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'adminEmail': value.adminEmail,
    };
}

